module.exports = __webpack_public_path__ + "img/bfcpzs00.f4af99da.png";